module.exports = __webpack_public_path__ + "img/animal-crossing.06f1f4ec.png";